var reInitGCaptcha;

(function($) {
    reInitGCaptcha = function() {
        $.getScript("https://www.google.com/recaptcha/api.js?render=6Leb3ZgUAAAAAMa8NwDnqlTMg7ciQ9rzYc176NVn").done(function () {
            grecaptcha.ready(function () {
                grecaptcha.execute('6Leb3ZgUAAAAAMa8NwDnqlTMg7ciQ9rzYc176NVn', {action: 'form'})
                    .then(function (token) {
                        $('#g-token').val(token);
                    });
            });
        });
    };
    
    if ($('form[data-recaptcha]').length) {
        reInitGCaptcha();
    }
    
    fn_nl_lib_anchor();

    doc.on('submit', 'form[data-component-ajax]', function (e) {
        e.preventDefault();
        let frm = $(this),
            formData = new FormData($(this)[0]);

        var submitButton = $(this).find('button[type="submit"]');
        if(submitButton.length) {
            submitButton.attr('disabled','disabled');
            submitButton.addClass('mod--loading');
        }

        $.ajax({
            method: frm.attr('method'),
            url: frm.attr('action'),
            data: formData,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function (payload) {
                fn_ajaxHandler(payload, function() {
                    sr.sync();
                    
                    if(submitButton.length) {
                        setTimeout(function() {
                            submitButton.removeAttr('disabled');
                            submitButton.removeClass('mod--loading');
                        },3000);
                    }
                    
                    if ($('form[data-recaptcha]').length) {
                        reInitGCaptcha();
                    }
                });
            }
        });
    });
    
    doc.on('click','a[data-component-ajax]',function(e) {
        e.preventDefault();
        let url = $(this).attr('data-href');
        if(!url || !url.length) {
            url = $(this).attr('href');
        }

        if(!url || !url.length) {
            console.log('no href attribute for ajax component link');
            return;
        }

        $.ajax({
            url: url,
            method: 'post',
            dataType: 'json'
        }).done(function (payload) {
            fn_ajaxHandler(payload,function() {
                ScrollReveal().sync();
            });
        });
    });

    cssLoaded(function () {
        $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();
        doc.on('lazybeforeunveil', '.lazyload', function(e){
            if ($(e.target).parent().hasClass("lib--parallax")) {
                $(e.target).parent().parallax();
            }
        });
        $("#layout_main").css("background-image","url("+$("#layout_main").data("bg")+")");
    });

    nl_lib_dialog.init(function(){
        let dialog_selector = doc.find(".lib--dialog");
        Object.keys(window.lui.lib).forEach(function(key) {
            let s = window.lui.lib[key].selector;
            if (dialog_selector.find(s[0]).length) {
                window.lui.lib[key](dialog_selector.find(s[0]),s[1])
            }
        });
        doc.off("keyup");
        doc.one("keyup",function (e) {
            if(e.originalEvent.key === "ArrowRight") {
                let arrow = dialog_selector.find(".elm_arrow.next").first();
                if(arrow.length) {
                    arrow.click();
                }
            }
            if(e.originalEvent.key === "ArrowLeft") {
                let arrow = dialog_selector.find(".elm_arrow.previous").first();
                if(arrow.length) {
                    arrow.click();
                }
            }
        });
    });

    $.libInit(".part_ui_link, .part_ui_checkbox, .part_ui_radio, .part_ui_btn", "lib_ripple", function(selector) {
        $(selector).nl_lib_ripple();
    });

    $.libInit("textarea", "lib_autosize", function(selector) {
        $.importScript(cdnjs.autosize, function(){
            cssLoaded(function(){
                autosize($(selector));
            });
        });
    });

    (function fn_pictureFill() {
        let picture = document.createElement('picture'),
            strObj = '' + picture;

        if(strObj.indexOf("HTMLPictureElement") === -1 && !html.hasClass("ie"))
        {
            $.importScript(cdnjs.picturefill);
        }
    })();

    if ($(".part_cookie_consent").length || $(".part_form_cookies").length) {
        $.importScript(cdnjs.cookieconsent);
    }
})(jQuery);